// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1R_Eh","modalFooterButton":"ModalNotes_modalFooterButton__3FFnA"};